import React from 'react'
import { Switch } from 'react-router-dom'
import { withRegionSwitchHandler } from 'core/page/withRegionSwitchHandler'

import ExternalGMSList from 'gms-support/src/app-support/external-gms/components/List'
import New from 'gms-support/src/app-support/external-gms/components/New'
import Edit from 'gms-support/src/app-support/external-gms/components/Edit'
import PermissionRoute from 'app-support/permissions/PermissionRoute'
import { PERMISSION_MANAGE_EXTERNAL_GMS } from 'app-support/permissions/Permissions'
import { externalGMSRoute, externalGMSRouteEdit, externalGMSRouteNew } from 'routes/routeNames'

const enhance = withRegionSwitchHandler(externalGMSRoute)

const ExternalGMSContainer: React.FC<{}> = () => (
  <Switch>
    <PermissionRoute permission={PERMISSION_MANAGE_EXTERNAL_GMS} exact path={externalGMSRoute} component={ExternalGMSList} />
    <PermissionRoute permission={PERMISSION_MANAGE_EXTERNAL_GMS} exact path={externalGMSRouteNew} component={New} />
    <PermissionRoute permission={PERMISSION_MANAGE_EXTERNAL_GMS} exact path={externalGMSRouteEdit} component={Edit} />
  </Switch>
)

export default enhance(ExternalGMSContainer)
